export const items = [
  {
    name: 'Inicio',
    translation: 'Header.HeaderDesktop.MenuList.Home',
    link: 'home',
    icon: 'home',
    class: null
  },
  {
    name: 'Organizaciones',
    translation: 'Header.HeaderDesktop.MenuList.Messages',
    link: 'organizations',
    icon: 'organization',
    class: null
  },
  {
    name: 'Suscriptores',
    translation: 'Header.HeaderDesktop.MenuList.Subscribers',
    link: 'subscribers',
    icon: 'subscribers',
    class: null
  }
]
